import { render, staticRenderFns } from "./AccordionParts.vue?vue&type=template&id=da020460&scoped=true&lang=pug"
import script from "./AccordionParts.vue?vue&type=script&lang=js"
export * from "./AccordionParts.vue?vue&type=script&lang=js"
import style0 from "./AccordionParts.vue?vue&type=style&index=0&id=da020460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da020460",
  null
  
)

export default component.exports